module.exports = __webpack_public_path__ + "img/business_img02.5c923b75.jpg";